import { Brand } from '../Brand';
import { matchesApex } from '../HostUtils';

export const TABLERUN_APEX_HOST = 'tablerun.com';

export const isTableRunHostname = (hostname: string): boolean => matchesApex(hostname, TABLERUN_APEX_HOST);

const isTableRunHref = (href: string | null | undefined): boolean => {
  if (!href) {
    return false;
  }
  try {
    return isTableRunHostname(new URL(href).hostname);
  } catch {
    return false;
  }
};

/**
 * The brand of the page a request came from, read from the browser URL shef-web sends as
 * `x-shef-href` — the API never sees the browser's own `Host`.
 *
 * Only TableRun's own hosts produce {@link Brand.TableRun}; an absent, malformed or unrecognised
 * href is Shef.
 */
export const brandForHref = (href: string | null | undefined): Brand =>
  isTableRunHref(href) ? Brand.TableRun : Brand.Shef;
